// extracted by mini-css-extract-plugin
module.exports = {"card":"CardProduct_card__2ZM2-","img":"CardProduct_img__3NggJ","title":"CardProduct_title__1igum","bottom":"CardProduct_bottom__3KK6V","price":"CardProduct_price__1Fi2Y"};